import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("rops_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const refreshMe = useCallback(async () => {
    const token = localStorage.getItem("rops_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("rops_user", JSON.stringify(data));
    } catch {
      localStorage.removeItem("rops_token");
      localStorage.removeItem("rops_user");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshMe();
  }, [refreshMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rops_token", data.access_token);
    localStorage.setItem("rops_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const setupPdg = async (payload) => {
    const { data } = await api.post("/auth/setup-pdg", payload);
    localStorage.setItem("rops_token", data.access_token);
    localStorage.setItem("rops_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("rops_token");
    localStorage.removeItem("rops_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setupPdg, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
